import { actionCreator } from '@ardoq/rxbeach';
import type { ArdoqId } from '@ardoq/api-types';

const DOMAIN = '[transformations]';

export type FutureStateKey = {
  initiativeId: ArdoqId;
  futureStateId: ArdoqId;
};

export type FutureStateApprovalPayload = FutureStateKey & {
  description?: string;
};

export const approveFutureStateRequested =
  actionCreator<FutureStateApprovalPayload>(
    `${DOMAIN} FUTURE_STATE_APPROVE_REQUESTED`
  );

export const approveFutureStateSucceeded = actionCreator<FutureStateKey>(
  `${DOMAIN} FUTURE_STATE_APPROVE_SUCCEEDED`
);

export const approveFutureStateFailed = actionCreator<FutureStateKey>(
  `${DOMAIN} FUTURE_STATE_APPROVE_FAILED`
);

export const unapproveFutureStateRequested =
  actionCreator<FutureStateApprovalPayload>(
    `${DOMAIN} FUTURE_STATE_UNAPPROVE_REQUESTED`
  );

export const deleteFutureStateRequested = actionCreator<FutureStateKey>(
  `${DOMAIN} FUTURE_STATE_DELETE_REQUESTED`
);

export const mergeFutureStateClaimsRequested = actionCreator<FutureStateKey>(
  `${DOMAIN} FUTURE_STATE_MERGE_CLAIMS_REQUESTED`
);

export const mergeModalOpened = actionCreator(
  `${DOMAIN} FUTURE_STATE_MERGE_MODAL_OPENED`
);

export const mergeModalClosed = actionCreator(
  `${DOMAIN} FUTURE_STATE_MERGE_MODAL_CLOSED`
);
